import React from 'react';
export function Footer() {
  return <footer className="bg-[#080C18] border-t border-[#1E293B] py-7 px-5 text-center" data-id="element-124">
      <p className="text-[13px] text-brand-gray leading-[1.8]" data-id="element-125">
        © 2025 Sistema IA Universitario · Todos los derechos reservados
        <br data-id="element-126" />
        <a href="#" className="text-brand-blue hover:underline" data-id="element-127">
          Política de privacidad
        </a>{' '}
        ·{' '}
        <a href="#" className="text-brand-blue hover:underline" data-id="element-128">
          Términos y condiciones
        </a>
      </p>
    </footer>;
}